/* unplugin-vue-components disabled */import { render } from "./xdrawer.vue?vue&type=template&id=4d103bee"
import script from "./xdrawer.vue?vue&type=script&lang=js"
export * from "./xdrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__